export enum MessageModifiers {
    Tax = "german-taxes-message"
}